import { render, staticRenderFns } from "./modal1.vue?vue&type=template&id=1d1c0b66&scoped=true&"
import script from "./modal1.vue?vue&type=script&lang=js&"
export * from "./modal1.vue?vue&type=script&lang=js&"
import style0 from "./modal1.vue?vue&type=style&index=0&id=1d1c0b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c0b66",
  null
  
)

export default component.exports